import React from "react";
import { useSelector } from "react-redux";
import { getImageUrl } from "../../common/Funcation";

const DEFAULT_SPORTS_BANNER = "./images/sportsSliderNew.png";

const SportsBanner = () => {
  const DD = useSelector((e: any) => e.domainDetails);
  if (DD?.sportsBanner === false) return null;

  const customImage = DD?.sportsBannerImage
    ? getImageUrl(DD.sportsBannerImage)
    : "";

  return (
    <div className="cricket_img">
      <img src={customImage || DEFAULT_SPORTS_BANNER} alt="" />
    </div>
  );
};

export default SportsBanner;
